import React from 'react';

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

type BooleanFilterValue = 'true' | 'false' | '';

interface Props {
  label: string;
  value: BooleanFilterValue;
  onChange: (newValue: BooleanFilterValue) => void;
}

export default function AccommodationBooleanFilterInput({ label, value, onChange }: Props) {
  const labelId = `${label.toLowerCase().replace(/\s+/g, '-')}-label`;

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value}
        onChange={(e: SelectChangeEvent) => onChange(e.target.value as BooleanFilterValue)}
        label={label}
      >
        <MenuItem value="">Any</MenuItem>
        <MenuItem value="true">Yes</MenuItem>
        <MenuItem value="false">No</MenuItem>
      </Select>
    </FormControl>
  );
}
